/**
 * Project page, opening — the cover in a browser on the paper side, the
 * stack (or the services) in a terminal at night, the project number in
 * the seal; or the "closed shop" when there is no such project. The markup
 * is the server's (templates/site/sections/project/opening.html.twig).
 *
 * @module sections/project/opening
 */

import { animateSplitAway } from '../../components/split.js';

export const animate = animateSplitAway;
